module.exports = __webpack_public_path__ + "static/media/list-white.c2b40266.svg";